<template>
  <div class="wrap">
    <div class="circle"></div>
    如需修改服务机构或签约团队，可在【变更签约】页面进行申请
  </div>
</template>
<script setup lang="ts"></script>
<style scoped lang="less">
.wrap {
  display: flex;
  position: relative;
  margin: 36px 36px 16px;
  line-height: 36px;
  text-align: left;
  font-size: 24px;
  color: #667082;

  .circle {
    margin: 8px 16px 0;
    border-radius: 50%;
    width: 8px;
    height: 8px;
    background: #667082;
  }
}
</style>
